import { bool, func } from 'prop-types';
import React from 'react';
import { Button, Card, CardBody } from 'reactstrap';

import TimeStamp from '../generic/TimeStamp';
import { approvalShape } from '../prop-types';
import api from '../REST/api';
import withApiRequest from '../REST/with-api-request';
import { byType as TYPES } from './approval-types';
import ApprovalStatus from './ApprovalStatus';
import { APPROVAL_STATUSES, APPROVAL_TYPES } from './constants';
import DeleteApprovalButton from './DeleteApprovalButton';

function Approval({ model, onRequest, response, loading }) {
  const approval = response || model;
  const {
    status,
    id,
    opportunityId,
    createdBy,
    created,
    type,
    teamId,
    lastModifiedBy,
  } = approval;

  const TYPE = TYPES[type];
  const isGrantedOrDenied =
    status === APPROVAL_STATUSES.GRANTED || status === APPROVAL_STATUSES.DENIED;
  const showApprover = type === APPROVAL_TYPES.creatives && isGrantedOrDenied;

  return (
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex justify-content-between mb-4">
          <span className="text-muted small">
            {showApprover && (
              <>
                By <span className="font-weight-bold">{lastModifiedBy}</span>{' '}
                <br />{' '}
              </>
            )}
            <TimeStamp>{created}</TimeStamp>
          </span>
          <ApprovalStatus className="mb-5" status={status} />
        </div>
        <p className="mb-0">
          <span className="font-weight-bold">{createdBy}</span> requested an
          approval for {TYPE.renderTargetRepresentation(approval)}.{' '}
          {TYPE.whoCanGrant(teamId)}
        </p>
        <div className="d-flex mt-4">
          <div className="btn-group flex-1 mr-4" role="group">
            {status !== APPROVAL_STATUSES.GRANTED && (
              <Button
                color="success"
                disabled={loading}
                onClick={() => {
                  return onRequest(opportunityId, id, {
                    status: APPROVAL_STATUSES.GRANTED,
                  });
                }}
              >
                Grant
              </Button>
            )}
            {status !== APPROVAL_STATUSES.DENIED && (
              <Button
                color="danger"
                disabled={loading}
                onClick={() => {
                  return onRequest(opportunityId, id, {
                    status: APPROVAL_STATUSES.DENIED,
                  });
                }}
              >
                Deny
              </Button>
            )}
          </div>
          <div>
            {status !== APPROVAL_STATUSES.GRANTED && (
              <DeleteApprovalButton
                opportunityId={opportunityId}
                approval={approval}
              />
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

Approval.propTypes = {
  model: approvalShape.isRequired,
  onRequest: func.isRequired,
  loading: bool.isRequired,
  response: approvalShape,
};

Approval.defaultProps = {
  response: null,
};

export default withApiRequest({
  query: api.patchApproval,
  error: 'flash',
})(Approval);
